module.exports = __webpack_public_path__ + "media/images/emblems/Schwanden_bei_Brienz-coat_of_arms-62ce29e47d2bd437bc7e396c24db6ab2.svg";